<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-navigation-drawer :mini-variant="mini" :color="mainColor" v-model="drawer" app hide-overlay
      :permanent="this.$vuetify.breakpoint.xsonly" v-if="loggedIn && !mobile">
      <v-list-item class="px-0 pt-2">
        <v-img :src="logo"></v-img>
      </v-list-item>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
export default {
  name: "app-navbar",
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentLanguage() {
      return this.$store.state.auth.language || "de";
    },
    mini() {
      let mobileTmp = this.$vuetify.breakpoint.mdAndDown;
      if (!mobileTmp) {
        return this.drawer;
      } else {
        return true;
      }
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  watch: {
    loggedIn() {
      this.mainColor = this.$vuetify.theme.themes.light.primary;
      this.logo = this.currentUser
        ? this.currentUser.whitelabeling_pack.logo
        : require("../../assets/img/logo_w_small.svg");
    },
  },
  created() {

    this.mobile = this.$vuetify.breakpoint.mdAndDown;
    this.mainColor = this.$vuetify.theme.themes.light.primary;

    this.logo = this.currentUser
      ? this.currentUser.whitelabeling_pack.logo
      : require("../../assets/img/logo_w_small.svg");
  },
  data() {
    return {
      drawer: false,
      mobile: false,
      mainColor: "",
      logo: "",
    };
  },
};
</script>
